import { t } from "i18next";
import { capitalize } from "neetocist";
import { Typography } from "neetoui";
import { fromPairs, toPairs } from "ramda";

import MoreDropdown from "components/MoreDropdown";

export const formatLabel = label => capitalize(label.trim());

export const formatDataForTable = taxonomies =>
  toPairs(taxonomies).map(([keyName, labels]) => ({
    keyName,
    singularLabel: labels["singular"],
    pluralLabel: labels["plural"],
  }));

export const getColumnData = ({
  columnLabels,
  columnsToShow,
  handleEdit,
  setCurrentKeys,
  setIsResetModalOpen,
}) => {
  const {
    singularColumn: showSingularColumn = true,
    pluralColumn: showPluralColumn = true,
  } = columnsToShow;

  const {
    singular: singularLabel = t("neetoMolecules.taxonomy.singularLabel"),
    plural: pluralLabel = t("neetoMolecules.taxonomy.pluralLabel"),
  } = columnLabels;

  return [
    {
      title: t("neetoMolecules.taxonomy.defaultLabel"),
      dataIndex: "default",
      key: "defaultLabel",
      width: 400,
      render: (_, values) => {
        const menuItems = [
          {
            key: "edit",
            label: t("neetoMolecules.common.actions.edit"),
            onClick: () => handleEdit(values),
          },
          {
            key: "reset",
            label: t("neetoMolecules.common.actions.resetToDefaults"),
            onClick: () => {
              setCurrentKeys([values.keyName]);
              setIsResetModalOpen(true);
            },
          },
        ];

        return (
          <div className="flex items-center justify-between gap-x-3">
            <Typography style="body2">
              {t(`taxonomyDefaultLabels.${values.keyName}.singular`)}
            </Typography>
            <MoreDropdown
              {...{ menuItems }}
              dropdownButtonProps={{
                "data-testid": `nui-dropdown-icon-${values.keyName}`,
                className: "me-1 my-1",
              }}
              dropdownProps={{
                strategy: "fixed",
                placement: "bottom-end",
                appendTo: () => document.body,
              }}
            />
          </div>
        );
      },
    },
    ...(showSingularColumn
      ? [
          {
            title: singularLabel,
            dataIndex: "singularLabel",
            key: "singularLabel",
            width: 300,
          },
        ]
      : []),
    ...(showPluralColumn
      ? [
          {
            title: pluralLabel,
            dataIndex: "pluralLabel",
            key: "pluralLabel",
            width: 300,
          },
        ]
      : []),
  ];
};

export const getFilteredTaxonomies = (matchString, taxonomies) => {
  const filteredArray = toPairs(taxonomies).filter(([key, value]) => {
    const defaultLabel = t(`taxonomyDefaultLabels.${key}.singular`);
    const valuesToSearch = [defaultLabel, ...Object.values(value)];

    return valuesToSearch.some(str =>
      str.toLowerCase().includes(matchString.toLowerCase())
    );
  });

  return fromPairs(filteredArray);
};
